// Subsystem copy for the ZEUS hover callouts.
// ids must stay in sync with FILE_SYS in scripts/process-subs.mjs
export const SUBSYSTEMS = {
  1: {
    no: "01",
    name: "Holonomic mecanum drive",
    desc: "Four mecanum wheels give ZEUS full holonomic control, driven by motors situated just millimetres from the ground for a low centre of gravity.",
  },
  2: {
    no: "02",
    name: "Intake slides",
    desc: "Gear-driven, high-speed horizontal Misumi slides that extend deep into the submersible zone to reach samples.",
  },
  3: {
    no: "03",
    name: "Intake claw",
    desc: "A compact wrist-mounted claw that is highly effective at precisely selecting samples at full slide extension.",
  },
  4: {
    no: "04",
    name: "Intake turret",
    desc: "Driven by an Axon MAX servo and continuous computer vision detecting game elements at 90hz, the intake turret auto-targets samples at any angle without any re-aligning of the slides.",
  },
  5: {
    no: "05",
    name: "Passthrough slides",
    desc: "Sported by Theseus since the National Championship and an iconic inspiration from our friends Proxima Nova, cascade-strung MGN7 linear rails allow ZEUS to score with a specimen cycle time of less than 1.5 seconds.",
  },
  6: {
    no: "06",
    name: "Deposit slides",
    desc: "Fully modular and able to be disassembled in less than 3 minutes, ZEUS's vertical slides are belt driven for speed. Combined with the Power Take-Off system, they allow ZEUS to haul itself onto the submersible with ease.",
  },
  7: {
    no: "07",
    name: "Outtake turret",
    desc: "Belt-driven by an Axon MAX servo, ZEUS features an auto-aligning outtake powered by inverse kinematics that enables true touch-and-go specimen pickup and deposit, all while the drivetrain sets up for the next cycle.",
  },
  8: {
    no: "08",
    name: "Outtake claw",
    desc: "The patented GloveClaw by Luke Jacobsen. The outtake claw forms the last robot-to-game-element contact of every cycle, releasing samples and specimens exactly where they score.",
  },
};
